import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"

// Magnetic hover: the element drifts toward the cursor when nearby, returning
// to rest on leave. Tunable by data-magnetic-strength-value (px max offset).
//
// <a data-controller="magnetic" data-magnetic-strength-value="18">…</a>
export default class extends Controller {
  static values = { strength: { type: Number, default: 14 } }

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this._onMove  = this._onMove.bind(this)
    this._onLeave = this._onLeave.bind(this)
    this.element.addEventListener("mousemove", this._onMove)
    this.element.addEventListener("mouseleave", this._onLeave)
  }

  disconnect() {
    this.element.removeEventListener("mousemove", this._onMove)
    this.element.removeEventListener("mouseleave", this._onLeave)
  }

  _onMove(e) {
    const r = this.element.getBoundingClientRect()
    const x = (e.clientX - r.left - r.width / 2)  / (r.width / 2)
    const y = (e.clientY - r.top  - r.height / 2) / (r.height / 2)
    gsap.to(this.element, {
      x: x * this.strengthValue,
      y: y * this.strengthValue,
      duration: 0.35,
      ease: "power3.out"
    })
  }

  _onLeave() {
    gsap.to(this.element, { x: 0, y: 0, duration: 0.6, ease: "elastic.out(1, 0.5)" })
  }
}
